module.exports = __webpack_public_path__ + "img/loppeonline_store_image.78b53e61.png";